import { AppState } from 'app/redux/types/types';

export const selectIsAuthenticated = (state: AppState): boolean => !!state.auth.authInfo;

export const selectHasAuthenticationFailed = (state: AppState) => state.auth.failed;
